module.exports = __webpack_public_path__ + "img/bg.4b2857be.png";